import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import "./PlatformSelectionModal.css";

// Export for testing
export const handleBackdropClick = (event) => {
  event.stopPropagation();
  return false;
};

function PlatformSelectionModal({ show, onContinue, onRedirectToNexus, onRedirectToAEF }) {

  const handleNexusRedirect = () => {
    // Redirect to Nexus platform
    window.location.href = process.env.REACT_APP_NEXUS_PLATFORM_URL || "https://nexus.deloitte.com";
  };

  const handleAEFRedirect = () => {
    // Redirect to AEF platform for US Consulting users
    window.location.href = process.env.REACT_APP_AEF_PLATFORM_URL || "https://engineeringplatforms.deloitte.com";
  };

  return (
    <Dialog
      open={show}
      onBackdropClick={handleBackdropClick}
      disableEscapeKeyDown={true}
      maxWidth="sm"
      fullWidth
      sx={{
        backdropFilter: "blur(5px)",
      }}
      aria-labelledby="platform-selection-dialog-title"
    >
      <DialogTitle
        id="platform-selection-dialog-title"
        sx={{
          background: "white",
          fontWeight: "bold",
          fontSize: "20px",
          paddingBottom: "8px",
        }}
      >
        Welcome to DT Global Enterprise Code Repository
      </DialogTitle>

      <DialogContent sx={{ paddingTop: "16px !important" }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "16px",
              fontSize: "16px",
              lineHeight: "1.6",
            }}
          >
            Thank you for accepting the Terms of Service!
          </Typography>

          <Typography
            variant="body2"
            sx={{
              marginBottom: "16px",
              fontSize: "14px",
              color: "#333",
              lineHeight: "1.6",
            }}
          >
            As a new US user, you must join Nexus to access Deloitte GitHub.
          </Typography>

          <Typography
            variant="body2"
            sx={{
              marginBottom: "16px",
              fontSize: "14px",
              color: "#333",
              lineHeight: "1.6",
            }}
          >
            <strong>US Consulting users</strong> requesting a Deloitte GitHub account must select <strong>Join AEF</strong> to request access to Deloitte US Consulting.
            <br /><br />
            If you already know which organization you want to join, select "Continue to ECR".
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "16px 24px",
          justifyContent: "center !important",
        }}
      >
        <Button
          onClick={onRedirectToNexus || handleNexusRedirect}
          variant="contained"
          sx={{
            backgroundColor: "#008080",
            color: "white",
            padding: "8px 24px",
            fontSize: "14px",
            fontWeight: "500",
            textTransform: "none",
            borderRadius: "3px",
            marginRight: "8px",
            "&:hover": {
              backgroundColor: "#006161",
            },
          }}
        >
          Join Nexus
        </Button>

        <Button
          onClick={onRedirectToAEF || handleAEFRedirect}
          variant="contained"
          sx={{
            backgroundColor: "#008080",
            color: "white",
            padding: "8px 24px",
            fontSize: "14px",
            fontWeight: "500",
            textTransform: "none",
            borderRadius: "3px",
            marginRight: "8px",
            "&:hover": {
              backgroundColor: "#006161",
            },
          }}
        >
          Join AEF
        </Button>

        <Button
          onClick={onContinue}
          variant="outlined"
          sx={{
            borderColor: "#008080",
            color: "#008080",
            padding: "8px 24px",
            fontSize: "14px",
            fontWeight: "500",
            textTransform: "none",
            borderRadius: "3px",
            "&:hover": {
              borderColor: "#006161",
              backgroundColor: "#f0f8f8",
            },
          }}
        >
          Continue to ECR
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PlatformSelectionModal;
